var map = {
	"./symbol_0.png": "e76a2",
	"./symbol_1.png": "ea9c",
	"./symbol_2.png": "9b56",
	"./symbol_3.png": "43a0",
	"./symbol_4.png": "8a97",
	"./symbol_5.png": "4113",
	"./symbol_6.png": "cbd1",
	"./symbol_7.png": "b13f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "efc9";